import React, { useLayoutEffect } from 'react';
import { AppTab } from './appLayoutConfig';
import OnboardingCalls from './dsl-components/OnboardingCalls';

interface OnboardingWrapperProps {
  threadId?: string;
  tabId?: string;
  onTabsReady?: (tabs: AppTab[]) => void;
}

// Define the tabs for onboarding threads
const ONBOARDING_TABS: AppTab[] = [
  { id: 'getting-to-know-you', label: 'Getting to know you' },
];

const OnboardingWrapper: React.FC<OnboardingWrapperProps> = ({
  threadId,
  tabId,
  onTabsReady,
}) => {
  // Notify parent about available tabs synchronously using useLayoutEffect
  // This ensures tabs are set before the parent's useEffect reset runs
  useLayoutEffect(() => {
    if (onTabsReady) {
      onTabsReady(ONBOARDING_TABS);
    }
  }, [onTabsReady]);

  // Render content based on tabId
  const renderContent = () => {
    switch (tabId) {
      case 'getting-to-know-you':
      default:
        return <OnboardingCalls threadId={threadId} />;
    }
  };

  return <div className='onboarding-wrapper'>{renderContent()}</div>;
};

export default OnboardingWrapper;
